export default {
  // Không xóa được hồ sơ Thủ trưởng từ chối duyệt
  CompanyDirectorReject: -2,
  // Không xóa được do hồ sơ đã được gửi cho KTT duyệt
  Waiting: 0,
  // Không xóa được do hồ sơ đã được gửi cho Thủ trưởng duyệt
  WaitingCompanyDirector: 2,
  // Không xóa được do hồ sơ đã được Thủ trưởng duyệt
  CompanyDirectorApproved: 3,
  //Không xóa được hồ sơ của Kế toán trưởng tự tạo
  CreatedByChiefAccountant: 5,
  // Không xóa được do hồ sơ đã được gửi cho ủy quyền KTT duyệt
  DelegateDelete: 99
};
